import * as React from "react";
import PropTypes from "prop-types";
import Slider from "@mui/material/Slider";
import { styled } from "@mui/material/styles";
import Tooltip from "@mui/material/Tooltip";
import Box from "@mui/material/Box";

const ValueLabelComponent = (props) => {
    const { children, value } = props;
    return (
        <Tooltip enterTouchDelay={0} placement="top" title={value}>
            {children}
        </Tooltip>
    );
};

ValueLabelComponent.propTypes = {
    children: PropTypes.element.isRequired,
    value: PropTypes.number.isRequired,
};

const marks = [
    {
        value: 15,
        label: "\u{1F9D1}",
    },
    {
        value: 47,
        label: "\u{1F30E}",
    },
];

const ExcellentSlider = styled(Slider)({
    color: "#52af77",
    height: 8,
    "& .MuiSlider-track": {
        border: "none",
    },
    "& .MuiSlider-thumb": {
        height: 24,
        width: 24,
        backgroundColor: "#fff",
        border: "2px solid currentColor",
        "&:focus, &:hover, &.Mui-active, &.Mui-focusVisible": {
            boxShadow: "inherit",
        },
        "&:before": {
            display: "none",
        },
    },
    "& .MuiSlider-valueLabel": {
        lineHeight: 1.2,
        fontSize: 12,
        background: "unset",
        padding: 0,
        width: 32,
        height: 32,
        borderRadius: "50% 50% 50% 0",
        backgroundColor: "#52af77",
        transformOrigin: "bottom left",
        transform: "translate(50%, -100%) rotate(-45deg) scale(0)",
        "&:before": { display: "none" },
        "&.MuiSlider-valueLabelOpen": {
            transform: "translate(50%, -100%) rotate(-45deg) scale(1)",
        },
        "& > *": {
            transform: "rotate(45deg)",
        },
    },
});

const MissionSectionSlider = ({ missionTarget, setMissionTarget, min, max, step, isDemo }) => {
    const handleChange = (event, newValue) => {
        setMissionTarget(newValue);
    };
    return (
        <Box sx={{ width: "262px", paddingTop: "42px", paddingBottom: "15px" }}>
            <ExcellentSlider
                valueLabelDisplay="auto"
                aria-label="mission goal slider"
                defaultValue={missionTarget}
                onChange={handleChange}
                marks={isDemo ? marks : null}
                min={min}
                max={max}
                step={step}
            />
        </Box>
    );
};

export default MissionSectionSlider;
